import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ObterEdicaoPorIdState } from '../../reducers/Jornal/obter-edicao-por-id.reducer';

export const selectObterEdicaoPorIdState = createFeatureSelector<ObterEdicaoPorIdState>('obterEdicaoPorId');

export const selectDadosObterEdicaoPorId = createSelector(
    selectObterEdicaoPorIdState,
    (state: ObterEdicaoPorIdState) => state.response
);

export const selectObterEdicaoPorId = createSelector(
  selectObterEdicaoPorIdState,
  (state: ObterEdicaoPorIdState) => state
);

export const selectErrosObterEdicaoPorId = createSelector(
    selectObterEdicaoPorIdState,
    (state: ObterEdicaoPorIdState) => state.error
);
